define([
  "globals",
  "base-view-model",
  "jquery",
  "knockout",
  "underscore",
  "postal",
  "product-option-view-model",
  "local-storage",
  "knockout-postbox",
  "visualizer"],
function(globals, baseViewModel, $, ko, _, postal, ProductOptionViewModel, LocalStorage) {

    function ProductChoiceSelectorViewModel(productId, siteProduct) {

    var self = this;
    ko.utils.extend(self, baseViewModel);

    self.blankColor = { name: ko.observable(""), image: ko.observable(""), selected: ko.observable(false) };
    self.selectedPrimaryColorName = ko.observable("");
    self.selectedPrimaryColorImage = ko.observable("");
    self.selectedPrimaryColorSelected = ko.observable(false);
    self.selectedSecondaryColorName = ko.observable("");
    self.selectedSecondaryColorImage = ko.observable("");
    self.selectedSecondaryColorSelected = ko.observable(false);
    self.selectedColorSwatches = ko.observable();
    self.isColorSelected = ko.observable();
    self.displayColor = ko.observable( false );
    self.options = ko.observableArray();
    self.siteProduct = siteProduct;
    self.colorSelectorPrice = ko.observable(globals.price).subscribeTo("colorSelectorPrice");
    self.shouldShowFullSecondarySwatch = ko.observable(false);

    self.hasStrikethroughPricing = ko.computed(function() {
        return siteProduct.pricingSubmodel().discountPrice().toFixed(2) !==
            siteProduct.pricingSubmodel().originalPrice().toFixed(2);
    })
      self.strikethroughMessage = ko.observable(globals.models.strikethroughPrice.Message).subscribeTo("strikethroughMessage");
      self.promoSnippet = ko.observable(globals.models.strikethroughPrice.PromoSnippet);

    this.optionsLoaded = ko.observable(false);
    this.productId = productId;
    self.widthOption = globals.models.widthOption;
    self.heightOption = globals.models.heightOption;
    self.width = undefined;
    self.height = undefined;

    self.logMouseOver = function ( data ) {
      console.log(data);
    }

    var productPageChannel = postal.channel("productpage");
    var localPersistance = new LocalStorage();

    // LOCAL FUNCTIONS
    var getSelectedChoices = function() {
      var choices = [];
      $.each(self.options(), function(indexA, productOption) {
        $.each(productOption.groups(), function(indexB, group) {
          $.each(group.choices, function(indexC, choice) {
            if (choice.selected()) choices.push(choice);
          });
        });
      });
      return choices;
    };

    var updateEditState = function() {
      var simpleSelectedChoices = [];
      $.each(getSelectedChoices(), function(index, choice) {
        simpleSelectedChoices.push({
          id: choice.id,
          optionId: choice.optionId
        });
      });

      if (simpleSelectedChoices.length === 0) {
        localPersistance.remove("option-state-" + productId);
        productPageChannel.publish("updatePrice");
      } else {
        var saveData = ko.toJSON(simpleSelectedChoices);
        localPersistance.persist("option-state-" + productId, saveData);
        productPageChannel.publish("updatePrice");
      }
    };

    var load = function() {

      var sampleableOptions = globals.models.sampleOptions;
      if (sampleableOptions) {
        var siteProductOptions = [];
        _.each(sampleableOptions.Options, function(option) {
          var siteProductOption = new ProductOptionViewModel(option, globals);
          siteProductOptions.push(siteProductOption);
        });
        self.options.push.apply(self.options, siteProductOptions);
        self.optionsLoaded(true);
        ko.applyBindings(self, $(".bdc-product-status")[0]);
        ko.applyBindings(self, $(".bdc-product-options-list")[0]);
        //ko.applyBindings(self, $("")[0]);
      }

      // get the color from the url
      var preSelectedColorId = $.getQueryStringValue("color");
      // find the option where the color belongs in the current collection
      var option = preSelectedColorId && _.find(self.options(), function(option) {
        return _.find(option.groups(), function(group) {
          return _.find(group.choices, function(choice) {
              return choice.id === +preSelectedColorId;
          });
        });
      });

      if (preSelectedColorId) {
        var selectedChoices = [];
        if (option) {
          selectedChoices.push({id:+preSelectedColorId, optionId:option.id});
        }

        _.each(selectedChoices, function (selected) {
          var selectedOption = _.find(self.options(), function (currentOption) {
            return currentOption.id === selected.optionId;
          });

          if (selectedOption) {
              productPageChannel.publish("selection.changed", selected);
              productPageChannel.publish("after.selection.change", option);
          }
        });
      }

      if (siteProduct && siteProduct.pricingSubmodel) {
        siteProduct.pricingSubmodel().publishDimensionsChangedEvent();
      }
      self.UpdateProductPreviewMicroApp();
    };

    var flagUnavailableChoices = function(response) {

      _.each(this.options(), function(option) {
        _.each(option.groups(), function(group) {
          _.each(group.choices, function(choice) {
            choice.isUnavailableInSize(false);
          });
        });
      });

      _.each(response.Data, function(unavailableChoices) {

        var currentOption = _.find(this.options(), function(option) {
          // TODO: Check if option.id() could arrive here as an observable. If not, use only option.id
          var optionId = typeof option.id === "number" ? option.id : option.id();
          return optionId === unavailableChoices.OptionId;
        });

        _.each(unavailableChoices.ChoiceIds, function(choiceId) {
          var unavailableChoice;
          if (currentOption) {
            _.each(currentOption.groups(), function(group) {
              unavailableChoice = _.find(group.choices, function(choice) {
                return choice.id === choiceId;
              });
              if (unavailableChoice) {
                unavailableChoice.isUnavailableInSize(true);
                if (unavailableChoice.selected()) unavailableChoice.toggleSelected();
              }
            }, this);
          }
        }, this);
      }, this);
    };

    var getUnavailableChoices = function(data) {
      self.width = data.width;
      self.height = data.height;
      self.UpdateProductPreviewMicroApp();

      $.ajax({
        type: "GET",
        url: globals.paths.unavailableChoices,
        data: {
          context: ko.toJSON(data.pricingContext)
        },
        context: this
      }).done(flagUnavailableChoices);
    };

    // GLOBAL FUNCTIONS
    self.displayColorSelectorPrice = ko.computed(function() {
      return self.optionsLoaded() && self.siteProduct.pricingSubmodel() && self.siteProduct.pricingSubmodel().price();
    });

    this.getSelectedChoiceByType = function(requestedType) {
      var selectedChoice;
      $.each(self.options(), function(indexA, productOption) {
        if (productOption.type === requestedType) {
          $.each(productOption.groups(), function(indexB, group) {
            $.each(group.choices, function(indexC, choice) {
              if (choice.selected()) {
                selectedChoice = choice;
                return selectedChoice;
              }
            });
          });
        }
      });
      return selectedChoice;
    };

    this.UpdateProductPreviewMicroApp = function() {
      const selectedOptions = [];
      // Get all options with their selected choices
      $.each(self.options(), function(indexA, productOption) {
        $.each(productOption.groups(), function(indexB, group) {
          $.each(group.choices, function(indexC, choice) {
            if (choice.selected()) {
              selectedOptions.push({
                choiceId: choice.choiceid,
                choiceName: choice.name,
                optionId: productOption.optionid,
                type: productOption.type,
                mediaUrl: choice.image,
              });
            }
          });
        });
      });

      // Width
      if (self.widthOption && self.width) {
        selectedOptions.push({
          choiceId: self.widthOption.ChoiceId,
          optionId: self.widthOption.OptionId,
          type: "Width",
          choiceValue: self.width.dimension.value()
        });
      }

      // Height
      if (self.heightOption && self.height) {
        selectedOptions.push({
          choiceId: self.heightOption.ChoiceId,
          optionId: self.heightOption.OptionId,
          type: "Height",
          choiceValue: self.height.dimension.value()
        });
      }

      const detail = {
        selectedOptions,
      };

      // Keep local storage up to date
      // Load almost never happens before this fires with defaults.
      var localVisModel = JSON.parse(localStorage.getItem('product-preview'));
      localVisModel = {
        ...localVisModel,
        selectedOptions,
      }
      localStorage.setItem('product-preview', JSON.stringify(localVisModel));

      window.dispatchEvent(new CustomEvent('product-preview', { bubbles: false, cancelable: true, detail }));
    }

    this.init = function() {
      return load();
    };

    // SUBSCRIPTIONS
    productPageChannel.subscribe("after.selection.change", function() {

      updateEditState();
      self.displayColor( true );
      var selectedPrimaryColor = self.getSelectedChoiceByType( "Primary Color" );
      var selectedSecondaryColor = self.getSelectedChoiceByType( "Secondary Color" );

      self.selectedPrimaryColorName(selectedPrimaryColor ? selectedPrimaryColor.name : "");
      self.selectedPrimaryColorImage(selectedPrimaryColor ? selectedPrimaryColor.image + "?mode=crop&width=50&height=50" : "");
      self.selectedPrimaryColorSelected(selectedPrimaryColor ? selectedPrimaryColor.selected() : false);
      self.selectedSecondaryColorName(selectedSecondaryColor ? selectedSecondaryColor.name : "");
      self.selectedSecondaryColorImage(selectedSecondaryColor ? selectedSecondaryColor.image + "?mode=crop&width=50&height=50" : "");
      self.selectedSecondaryColorSelected(selectedSecondaryColor ? selectedSecondaryColor.selected() : false);

      self.selectedColorSwatches({ primary: self.selectedPrimaryColorImage(), secondary: self.selectedSecondaryColorImage() });

      if (self.selectedPrimaryColorSelected() === false &&  self.selectedSecondaryColorSelected() === true) {
        self.shouldShowFullSecondarySwatch(true);
      } else {
        self.shouldShowFullSecondarySwatch(false);
      }

      if (self.selectedPrimaryColorSelected() || self.selectedSecondaryColorSelected()) {
        self.isColorSelected(true);
      } else {
        self.isColorSelected(false);
      }
      self.UpdateProductPreviewMicroApp();
    });

    postal.subscribe({
      topic: "dimensions.changed",
      callback: getUnavailableChoices
    }).context(this);

  }

  return ProductChoiceSelectorViewModel;

});
